module.exports = __webpack_public_path__ + "static/media/vod9.145a8ade.png";